import type { DrawnDynamic, DrawnStaff } from '@/music/notation/drawn';
import { curveObstacles } from '@/music/notation/curveObstacles';
import { dynamicBounds } from '@/music/notation/dynamicBounds';
import { slurTAtX, slurVerticalBounds, type StaffSlurCurve } from './slurGeometry';

/** Place dynamics below overlapping notation and slurs before row layout. */
export function staffDynamicPositions(
  staff: DrawnStaff,
  curves: StaffSlurCurve[],
): Map<DrawnDynamic, number> {
  const positions = new Map<DrawnDynamic, number>();
  staff.systems.forEach((sys, si) => {
    const boxes = curveObstacles(sys.measures);
    for (const m of sys.measures)
      for (const d of m.dynamics) {
        const b = dynamicBounds(d);
        const x0 = m.x + d.x + b.left,
          x1 = m.x + d.x + b.right;
        let y = d.y;
        const obstacles = boxes
          .filter((ink) => ink.right >= x0 && ink.left <= x1)
          .map((ink) => ({ top: ink.top, bottom: ink.bottom }));
        for (const sc of curves) {
          if (sc.si !== si) continue;
          const left = Math.max(sc.c.ax1, x0 - 0.2),
            right = Math.min(sc.c.ax2, x1 + 0.2);
          if (right < left) continue;
          const bounds = slurVerticalBounds(sc.c, slurTAtX(sc.c, left), slurTAtX(sc.c, right));
          obstacles.push({ top: bounds.top - 0.07, bottom: bounds.bottom + 0.07 });
        }
        // Outward order guarantees a move cannot re-enter an earlier obstacle.
        obstacles.sort((a, b) => a.bottom - b.bottom);
        for (const ink of obstacles) {
          if (ink.bottom < y + b.top - 0.4 || ink.top > y + b.bottom + 0.4) continue;
          y = Math.max(y, ink.bottom + 0.4 - b.top);
        }
        positions.set(d, y);
      }
  });
  return positions;
}
